import { render, staticRenderFns } from "./PDFUploader.vue?vue&type=template&id=8f10a1d2&"
import script from "./PDFUploader.vue?vue&type=script&lang=js&"
export * from "./PDFUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports